import Button from "../components/PriceButton"
import EmpoweredCommunity from "../images/shawna-friends.jpg"
import React, { Component } from 'react';
import cents from "../images/less-than-20-cents.png"
import styles from "../styles/joinCommunity.module.scss"

class JoinCommunity extends React.Component {
  constructor(){
    super()
    this.state = {
      haveEthos:false,
      ethosTitle1: '',
      ethosTitle2: '',
      ethosTitle3: '',
      ethosTitle4: '',
      ethosTitle5: '',
    }

  }


  componentDidMount(){
    const finalEthos = localStorage.getItem('haveEthos')
    
    const ethos1=localStorage.getItem('ethos1Title')
    const ethos2=localStorage.getItem('ethos2Title')
    const ethos3=localStorage.getItem('ethos3Title')
    const ethos4=localStorage.getItem('ethos4Title')
    const ethos5=localStorage.getItem('ethos5Title')
       if(finalEthos==='true'){
      this.setState({
        haveEthos:finalEthos,
        ethosTitle1:ethos1,
        ethosTitle2:ethos2,
        ethosTitle3:ethos3,
        ethosTitle4:ethos4,
        ethosTitle5:ethos5,
      })
    }
    
  }



  render(){
    
    
  return (
    <section className={styles.joinCommunity}>
      <div className={styles.joinCommunity_inner}>
        <div className={styles.joinCommunity_inner_txt}>
          <h2 className={styles.joinCommunity_inner_txt_inner}>
            <span className={styles.joinCommunity_inner_txt_inner__join}>
              join the <br />
            </span>
            <span className={styles.joinCommunity_inner_txt_inner__empowered}>
              {" "}
              em
              <span
                className={
                  styles.joinCommunity_inner_txt_inner__empowered_power
                }
              >
                •power
              </span>
              ed <br />{" "}
            </span>
            <span className={styles.joinCommunity_inner_txt_inner__community}>
              community
            </span>
          </h2>
          <div className={styles.greatness}>
            <p className={styles.title}>Let's step into greatness together.</p>
            <div className={styles.buttons}>
              
              <div className={styles.c_button}>
                  {this.state.haveEthos?  
            <Button
            href={`https://member.empowerofyou.com/checkout/?add-to-cart=4741&ethos1=${this.state.ethosTitle1}&ethos2=${this.state.ethosTitle2}&ethos3=${this.state.ethosTitle3}&ethos4=${this.state.ethosTitle4}&ethos5=${this.state.ethosTitle5}`}
            backgroundColor={"#ffbe76"}
            label={"FULL POWER PROGRAM"}
            fontSize={"22px"}
            price={"5.99"}
            length={"month"}
            />
            : 
            <Button
              href={"https://member.empowerofyou.com/checkout/?add-to-cart=4741"}
              backgroundColor={"#ffbe76"}
              label={"FULL POWER PROGRAM"}
              fontSize={"22px"}
              price={"5.99"}
              length={"month"}
            />
  }
              
                <p>
                  workouts <span className={styles.blue}>|</span> meditations <span className={styles.blue}>|</span> challenges
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.joinCommunity_inner_img}>
          <img
            className={styles.joinCommunity_inner_img_girls}
            loading="lazy"
            alt="Shawna and Community"
            src={EmpoweredCommunity}
          />
          <img
            className={styles.joinCommunity_inner_img_cost}
            loading="lazy"
            src={cents}
            alt="less than 20 cents a day"
          />
        </div>
      </div>
    </section>
  )
}
}

export default JoinCommunity
